import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from "moment";
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createIssue,
  updateIssue,
  deleteIssue,
  getIssue,
  getIssueList } from '../../../services/IssueService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class IssuePageList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      dataList: []
    };

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    let dataList = await getIssueList();
    /*
    log.debug(dataList.length)
    dataList.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
    });
    */

    log.debug('all data is loaded.')
    this.setState({dataList: dataList})
    this.setState({isLoading: false})
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
          <h4 className="page-header">
          <Link to='/issue'>Issue</Link> ->
          List
        </h4>
          <table className="table">
              <thead>
                  <tr>
                      <th> issue_id </th>

                      {/* <th>issue_uuid</th>  */}
                      <th>magazine_id</th>
                      {/* <th>owner_id</th>  */}
                      <th>tag</th>
                      <th>title</th>
                      {/* <th>description</th>  */}
                      <th>is_publish</th>
                      {/* <th>issue_version</th>
                      <th>cover_width</th>
                      <th>cover_height</th>
                      <th>cover_url</th>
                      <th>issue_download_url</th>
                      <th>download_success_msg_title</th>
                      <th>download_success_msg_body</th>
                      <th>notify_cover_number</th>
                      <th>share_text</th>
                      <th>embed_html</th>  */}
                      {/* <th>date_released</th>
                      <th>date_modified</th>  */}
                      <th>date_created</th>
                      <th>status</th>
                      <th> Actions </th>
                  </tr>
              </thead>
              <tbody>
                {
                  this.state.dataList.map((data, index) =>
                  <tr key={index}>
                    <td>{data.id}</td>

                      {/* <td>{data.data().issue_uuid} </td>  */}
                      <td>{data.data().magazine_id} </td>
                      {/* <td>{data.data().owner_id} </td>  */}
                      <td>{data.data().tag} </td>
                      <td>{data.data().title} </td>
                      {/* <td>{data.data().description} </td>  */}
                      <td>{data.data().is_publish} </td>
                      {/* <td>{data.data().issue_version} </td>
                      <td>{data.data().cover_width} </td>
                      <td>{data.data().cover_height} </td>
                      <td>{data.data().cover_url} </td>
                      <td>{data.data().issue_download_url} </td>
                      <td>{data.data().download_success_msg_title} </td>
                      <td>{data.data().download_success_msg_body} </td>
                      <td>{data.data().notify_cover_number} </td>
                      <td>{data.data().share_text} </td>
                      <td>{data.data().embed_html} </td>  */}
                      {/* <td>{data.data().date_released} </td>
                      <td>{data.data().date_modified} </td>  */}
                      <td>{moment(data.data().date_created).fromNow()}</td>
                      <td>{data.data().status} </td>
                    {/* <td>{moment(data.data().date_created).fromNow()}</td> */}
                    <td>
                      <Link className="btn btn-small btn-primary" to={`/issue/view/${data.id}`}>view</Link>
                    </td>
                  </tr>
                )
                }
              </tbody>
          </table>
          {/* <p>
              <Link className="btn btn-success" to='/issue/add'>Add New Issue</Link>
          </p> */}
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/IssuePage/IssuePageList.js